<template>
  <b-card :class="[dark ? 'dark-mode-page' : '']" >
    <b-row>
      <b-col class="form-group col-6">
        <label :class="[dark ? 'text-white': '']" >Fecha inicio:</label>
        <!-- :min="beforeMonth" -->
        <!-- :max="form.date_end" -->
        <input
          v-model="form.date_init"
          :disabled="isLoading"
          type="datetime-local"
          class="form-control form-control-sm"
        />
      </b-col>
      <b-col class="form-group col-6">
        <label :class="[dark ? 'text-white': '']" >Fecha fin:</label>
        <input
          v-model="form.date_end"
          :disabled="isLoading"
          :min="form.date_init"
          type="datetime-local"
          class="form-control form-control-sm"
        />
      </b-col>
      <b-col>
        <button
          class="btn btn-sm btn-primary btn-circle"
          @click="onGenerateReportXslx()"
          :disabled="isLoading"
        >
          <span v-if="!isLoading">
            <i class="fa fa-regular fa-file-excel"></i>
            Generar Reporte
          </span>
          <span v-else>Cargando...</span>
        </button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { saveAs } from "file-saver-es";
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      isLoading: false,
      form: {
        date_init: moment().format("YYYY-MM-DDT06:00:00"),
        date_end: moment().format("YYYY-MM-DDT18:00:00"),
      },
    };
  },
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
    }),
  },
  methods: {
    async onGenerateReportXslx() {
      this.isLoading = true;
      try {
        const { status, data } = await axios.post(
          "/dashboard-report-xslx",
          this.form,
          { responseType: "arraybuffer" }
        );
        if (status === 200) {
          if (!data) {
            this.$swal.fire(
              "Información!",
              "No se ha encontrado informacion en ese rango de fechas!",
              "info"
            );
            this.isLoading = false;
            return;
          }

          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(
            blob,
            `avisos_bitacora_${moment().format("YYYY-MM-DD HH:mm")}.xlsx`
          );
        }
        this.isLoading = false;
      } catch (error) {
        console.log({ error });
        this.$swal.fire(
          "Error!",
          "Ocurrió un error al generar el reporte. Inténtelo nuevamente.",
          "error"
        );
        this.isLoading = false;
      }
    },
  },
};
</script>
